import { useQuery } from '@tanstack/react-query'
import { FormattedMessage } from 'react-intl'
import { useSearchParams } from 'react-router'

import { queryKeys } from '@/constants/queryKeys'
import { getContractorCompany } from '@/domains/Contractor/api'
import { getImage } from '@/lib/images'
import { Button, Typography } from '@/shared/ui'

export const SignAmendedContractToDo = () => {
  const [, setSearchParams] = useSearchParams()

  const contractorCompanyQuery = useQuery({
    queryKey: [queryKeys.getContractorCompany],
    queryFn: getContractorCompany,
    select: (data) => data.data,
  })

  return (
    <>
      <div className="flex flex-wrap items-center justify-between gap-8 md:flex-nowrap md:gap-0">
        <div className="flex flex-wrap md:flex-nowrap md:gap-3">
          <img
            className="w-8 object-contain"
            src={getImage({ name: 'todo-list', category: 'contractors' })}
            alt=""
            aria-hidden
          />

          <div className="flex flex-col justify-center">
            <Typography bold>
              <FormattedMessage
                id="contractor.toDo.amendedContract.title"
                defaultMessage="{name} has sent you an amendment to your contract"
                values={{
                  name: contractorCompanyQuery.data?.legalName,
                }}
              />
            </Typography>
            <Typography variant="body-small" className="text-neutral-gray-600">
              <FormattedMessage
                id="contractor.toDo.amendedContract.description"
                defaultMessage="Review and sign the amendment to make changes to the contract effective"
              />
            </Typography>
          </div>
        </div>

        <Button
          onClick={() => {
            setSearchParams(
              (params) => {
                params.set('sign-contract', 'true')
                return params
              },
              { preventScrollReset: true },
            )
          }}
        >
          <FormattedMessage
            id="actions.reviewAndSign"
            defaultMessage="Review & sign"
          />
        </Button>
      </div>
    </>
  )
}
